const ColorCircle = ({ value }) => {
  return (
    <div className="flex h-full items-center text-xs text-neutral-600">
      <div className="!mr-2 h-6 w-6 rounded-full" style={{ backgroundColor: value }}></div>
      {value}
    </div>
  );
};

export default ColorCircle;
